/*
 * Copyright (c) 2022 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */


import { observable, action} from 'mobx';
import { launchDarklyUser } from '../../launchDarklyConfig';
import { initialize } from 'launchdarkly-js-client-sdk';
import { LDUser, LDClient } from 'launchdarkly-js-client-sdk';
import GlobalStore from '../../stores/GlobalStore/GlobalStore';
// NOTE:
// - flags are mobx observable either from the flags or your own computed
// property for convenience
// - you can use flags in stores or other non-React.Component locations
// (functions/classes) but the value can not be "reactive" outside a Component.

export type FeatureFlags = { [key: string]: boolean };

export interface Context { status: boolean };

/**
 * Base class for FeatureFlag Store
 */
export default abstract class FeatureFlagStore extends GlobalStore {

  @observable
  public featureFlags: FeatureFlags = {};

  protected client: LDClient | null = null;

  @action
   init = async (onInitialization: (...args: any[]) => void) => {
    await this.close();
    let user = this.getLDUserInfo();
    this.client = initialize(this.getLaunchDarklyEnvKey(), user);
    await this.client.waitForInitialization();
    this.setFeatureFlags(this.client);
    this.client.on('change', () => {
      this.setFeatureFlags(this.client!);
    });
    onInitialization();
    return this.client;
  };

  /**
   * close the LD client
   * @returns 
   */
  close() {
    return this.client?.close();
  }

  /**
   * helper function to create a LaunchDarkly User Object which will be passed during initialization
   * @returns 
   */
  getLDUserInfo = (): LDUser => {
    return launchDarklyUser;
  }

  abstract getLaunchDarklyEnvKey() : string;
  
  abstract setFeatureFlags(client: LDClient): void;
}
